import React, {PropTypes} from 'react';
import * as loginText from '../../../constants/loginText';

const ForgotPasswordConfirmationPage = (email) => {
  return (
    <div className="panel" id="email-validation">
      <div className="panel-body">
        <div className="row">
          <p>
            {loginText.forgotPasswordConfirmationEmail1}
            <strong>{email.email}</strong>
            {loginText.forgotPasswordConfirmationEmail2}
          </p>
          <p>
            {loginText.forgotPasswordConfirmationText}
          </p>
        </div>
      </div>
    </div>
  );
};
ForgotPasswordConfirmationPage.propTypes = {
  email: PropTypes.string.isRequired
};
export default ForgotPasswordConfirmationPage;



/** WEBPACK FOOTER **
 ** ./src/components/authentication/ForgotPassword/ForgotPasswordConfirmationPage.js
 **/